import { __decorate } from "tslib";
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { QuestionnaireEditModule } from "@/modules/newCommunity/pages/operationTools/dynimicStore";
let FillInMulti = class FillInMulti extends Vue {
  dataChage(value) {
    this.zItem = value;
  }
  get questionnaireType() {
    return this.businessType || QuestionnaireEditModule.questionnaireType;
  }
};
__decorate([Prop({
  type: String,
  default: "EDIT"
})], FillInMulti.prototype, "viewMode", void 0);
__decorate([Prop({
  type: Number,
  default: 0
})], FillInMulti.prototype, "zIndex", void 0);
__decorate([Prop({
  type: Boolean,
  default: true
})], FillInMulti.prototype, "showScore", void 0);
__decorate([Prop({
  type: String,
  default: ""
})], FillInMulti.prototype, "businessType", void 0);
__decorate([Prop({
  type: Boolean,
  default: true
})], FillInMulti.prototype, "Required", void 0);
__decorate([Watch("zIndex", {
  immediate: true
})
// eslint-disable-next-line
// watchIndex() {}
, Prop({
  type: Object,
  default: {}
})], FillInMulti.prototype, "item", void 0);
__decorate([Watch("item", {
  immediate: true,
  deep: true
})], FillInMulti.prototype, "dataChage", null);
FillInMulti = __decorate([Component({
  name: "fillInMulti"
})], FillInMulti);
export default FillInMulti;